import React, { FC, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { EntityVersionTable } from './EntityVersionTable';
import { Checked } from '../common/Checked';
import { IEntityVersionVm } from '@yakoffice/publisher-types';
import { useMultiSelect } from '../../components/use-multi-select/useMultiSelect';
import { ButtonGroup } from 'react-bootstrap';

interface PropTypes {
    className?: string,
    entitiesTitle?: string
    entityVersions: IEntityVersionVm[]
    allowSelection?: boolean,
    selectedEntityButtonName?: string,
    handleSelectedEntities?: (entityVms: IEntityVersionVm[]) => void
}

export const GroupByKindEntityVersionContent: FC<PropTypes> = ({
                                                                   entityVersions,
                                                                   allowSelection,
                                                                   selectedEntityButtonName,
                                                                   handleSelectedEntities
                                                               }) => {

    const [checkAll, setCheckAll] = useState(false);
    const [checkedEntities, setCheckedEntities] = useState<Checked<IEntityVersionVm>[]>(entityVersions.map(e => ({
        checked: checkAll,
        value: e
    })));
    const multiSelect = useMultiSelect<Checked<IEntityVersionVm>>({
        items: checkedEntities,
        selectItem: (item, selected) => {
            item.checked = selected;
            setCheckedEntities(prevState => prevState.map(p => p));
        }
    });

    useEffect(() => {
            setCheckAll(false);
            setCheckedEntities(entityVersions.map(e => ({ checked: false, value: e })));
        }
        , [entityVersions]);

    const handleCheckChange = (checkedEntity: Checked<IEntityVersionVm>, checked: boolean) => {
        multiSelect.handleItemSelection(checkedEntity, checked);
    };

    const handleCheckAll = () => {
        const newState = !checkAll;
        multiSelect.handleSelectAll(newState);
        setCheckAll(newState);
    };

    return (
        <div>
            <ButtonGroup className={`justify-content-end`}>
                {allowSelection && entityVersions.length > 0 &&
                    <Button
                        onClick={() => handleSelectedEntities && handleSelectedEntities(checkedEntities.filter(c => c.checked).map(c => c.value))}
                        disabled={!checkedEntities.find(ce => ce.checked)}
                        className="btn-primary mb-2"
                        data-testid="btnSelectedEntities"
                    >{selectedEntityButtonName}</Button>
                }
            </ButtonGroup>
            <EntityVersionTable checkedEntityVersions={checkedEntities}
                                displayCheckBoxes={!!allowSelection}
                                checkAll={checkAll}
                                handleToggleCheckAll={handleCheckAll}
                                handleCheckChanged={handleCheckChange}
            />
        </div>
    );
};
